export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '2000+', label: '热门剧集覆盖' },
    { value: '每日更新', label: '同步追剧不等待' },
    { value: '1080P', label: '高清流畅不缓冲' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20atmosphere%20with%20warm%20golden%20and%20amber%20light%20streaks%2C%20abstract%20film%20reel%20texture%20with%20soft%20bokeh%20lights%2C%20dramatic%20theater%20curtain%20feel%20with%20deep%20burgundy%20and%20charcoal%20tones%2C%20elegant%20cinematic%20backdrop%20for%20streaming%20platform%2C%20luxurious%20and%20immersive&width=1600&height=900&seq=hero-bg-6080&orientation=landscape"
          alt="6080新视觉影视 沉浸式追剧体验"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14 lg:gap-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 backdrop-blur-sm mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium tracking-wide">每日热剧更新 · 全网同步</span>
            </div>

            <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
              6080新视觉影视
              <br />
              <span className="text-primary-400">高清追剧首选平台</span>
            </h1>

            <p className="mt-2 text-base md:text-lg text-primary-300/80 font-medium">
              热门电视剧全集在线 · 最新剧集每日同步 · 免费高清无缓冲
            </p>

            <div className="mt-6 max-w-xl mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-background-100/75 leading-relaxed">
                6080新视觉影视汇聚全网热门电视剧资源，涵盖国产剧、韩剧、美剧、日剧等各类题材。平台每日同步更新最新剧集，提供1080P高清画质与流畅播放体验，无需注册即可免费在线观看。无论是追热播新剧还是回顾经典老剧，这里都是您的高清追剧第一站。
              </p>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-5 md:gap-8 justify-center lg:justify-start">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-100/60 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-xl border border-background-50/25 text-background-50 font-medium text-sm hover:bg-white/10 hover:border-background-50/40 transition-all duration-200 cursor-pointer text-center"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] shrink-0">
            <div className="relative">
              <div className="absolute -inset-1 rounded-2xl bg-gradient-to-br from-primary-500/30 via-accent-500/20 to-transparent blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-50/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20drama%20streaming%20collage%20with%20warm%20cinematic%20golden%20lighting%2C%20elegant%20costume%20drama%20visual%20with%20flowing%20silk%20fabric%2C%20modern%20urban%20drama%20scene%20with%20city%20night%20lights%2C%20dramatic%20poster-style%20composition%20with%20rich%20burgundy%20and%20amber%20accents%2C%20professional%20entertainment%20platform%20visual&width=1040&height=1280&seq=hero-poster-6080&orientation=portrait"
                  alt="6080新视觉影视 热门电视剧推荐"
                  className="w-full aspect-[4/5] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}